var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('the-layout-base', {
    attrs: {
      "isEndUser": true,
      "paddingBottom": "pb-0",
      "renderBackAndForthFooter": false,
      "isProgressDone": true,
      "showFooter": false
    }
  }, [_c('div', [!_vm.isLoading && !_vm.isError && !_vm.isSigned ? _c('div', _vm._l(_vm.signRequest.attachments, function (documentForm) {
    return _c('v-row', {
      key: documentForm.id,
      attrs: {
        "no-gutters": ""
      }
    }, [_c('v-col', {
      attrs: {
        "cols": "12"
      }
    }, [_c('sign-form-dialog', {
      attrs: {
        "signRequest": _vm.signRequest,
        "signFormEditor": _vm.$refs.signFormEditor || _vm.$refs.signFormEditorMobile
      },
      on: {
        "confirmed": _vm.confirmed
      }
    }), _vm.$vuetify.breakpoint.mdAndUp ? _c('sign-form-editor', {
      ref: "signFormEditor",
      refInFor: true,
      attrs: {
        "document": documentForm,
        "signRequest": _vm.signRequest
      },
      on: {
        "sign": _vm.onSign
      }
    }) : _c('sign-form-editor-mobile', {
      ref: "signFormEditorMobile",
      refInFor: true,
      attrs: {
        "document": documentForm,
        "signRequest": _vm.signRequest
      },
      on: {
        "sign": _vm.onSign
      }
    })], 1)], 1);
  }), 1) : _vm.isLoading ? _c('div', [_c('v-skeleton-loader', {
    staticClass: "mx-auto",
    attrs: {
      "type": "card-heading, list-item-two-line, image, card-heading, list-item-two-line, article, actions"
    }
  })], 1) : _vm.isError ? _c('div', [_c('v-card-title', {
    staticClass: "justify-center"
  }, [_vm._v(" " + _vm._s(_vm.$t(_vm.errorTitle)) + " ")]), _c('v-card-text', [_c('v-tooltip', {
    attrs: {
      "bottom": "",
      "nudge-right": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function fn(_ref) {
        var on = _ref.on;
        return [_c('v-img', _vm._g({
          staticClass: "mx-auto",
          attrs: {
            "src": require("@/assets/undraw/undraw_authentication_fsn5.svg"),
            "height": "300",
            "contain": ""
          }
        }, on))];
      }
    }])
  }, [_c('span', [_vm._v(_vm._s(_vm.$t("sign.Sign.noData")))])])], 1), _c('v-card-actions', {
    staticClass: "justify-center"
  }, [_vm._v(" " + _vm._s(_vm.$t("sign.Sign.error.message", {
    companyName: _vm.partner.companyName
  })) + " ")]), _c('v-card-actions', {
    staticClass: "justify-center"
  }, [_c('tooltip', {
    attrs: {
      "text": _vm.partner.settings.contact.email
    }
  }, [_c('v-btn', {
    attrs: {
      "href": "mailto:".concat('partner.settings.contact.email', "?subject=RE: ", _vm.$t(_vm.errorTitle), " [").concat(_vm.$route.params.signRequestId, "]"),
      "icon": ""
    }
  }, [_c('v-icon', [_vm._v(" mdi-email ")])], 1)], 1), _c('tooltip', {
    attrs: {
      "text": _vm.partner.settings.contact.phone
    }
  }, [_c('v-btn', {
    attrs: {
      "href": "tel:".concat(_vm.partner.settings.contact.phone),
      "icon": ""
    }
  }, [_c('v-icon', [_vm._v(" mdi-phone ")])], 1)], 1)], 1)], 1) : _vm.isSigned ? _c('div', [_c('sign-form-signed', {
    on: {
      "refresh": _vm.findSigned
    }
  })], 1) : _vm._e()])]);
}
var staticRenderFns = []

export { render, staticRenderFns }